import request from '@/utils/request'
import api from '../api'

export class Virtual {
  list(data) {
    return request({
      url: api.virtual.list,
      method: 'post',
      data
    })
  }
  lock(data) {
    return request({
      url: api.virtual.lock,
      method: 'post',
      data
    })
  }
  create(data) {
    return request({
      url: api.virtual.create,
      method: 'post',
      data
    })
  }
  vanHistory(data) {
    return request({
      url: api.virtual.vanHistory,
      method: 'post',
      data
    })
  }
  uploadMaterial(params) {
    return request({
      url: api.virtual.uploadMaterial,
      method: 'put',
      params
    })
  }
  reUploadMaterial(params) {
    return request({
      url: api.virtual.reUploadMaterial,
      method: 'put',
      params
    })
  }
  isCreate(params) {
    return request({
      url: api.virtual.isCreate,
      method: 'get',
      params
    })
  }
  materialDownload(params) {
    return request({
      url: api.virtual.materialDownload,
      method: 'put',
      params
    })
  }
  denominationlist(data) {
    return request({
      url: api.virtual.denominationlist,
      method: 'post',
      data
    })
  }
  exportDenomination(data) {
    return request({
      url: api.virtual.exportDenomination,
      method: 'post',
      data
    })
  }
  recharge(data) {
    return request({
      url: api.virtual.recharge,
      method: 'post',
      data
    })
  }
  refundApply(data) {
    return request({
      url: api.virtual.refundApply,
      method: 'post',
      data
    })
  }
  virtualDskList(data) {
    return request({
      url: api.virtual.virtualDskList,
      method: 'post',
      data
    })
  }
  virtualDskSkMb(params) {
    return request({
      url: api.virtual.virtualDskSkMb,
      method: 'get',
      params
    })
  }
  virtualDskCzMb(params) {
    return request({
      url: api.virtual.virtualDskCzMb,
      method: 'get',
      params
    })
  }
  virtualDskCreate(data) {
    return request({
      url: api.virtual.virtualDskCreate,
      method: 'post',
      data
    })
  }
  virtualDskDownload(data) {
    return request({
      url: api.virtual.virtualDskDownload,
      method: 'post',
      data
    })
  }
  virtualDCzRecharge(data) {
    return request({
      url: api.virtual.virtualDCzRecharge,
      method: 'post',
      data
    })
  }
  virtualRetrieve(params) {
    return request({
      url: api.virtual.virtualRetrieve,
      method: 'get',
      params
    })
  }
  isMultiExist(params) {
    return request({
      url: api.virtual.isMultiExist,
      method: 'get',
      params
    })
  }
  getCardProductList(params) {
    return request({
      url: api.virtual.getCardProductList,
      method: 'get',
      params
    })
  }
  batchMultiCreate(data) {
    return request({
      url: api.virtual.batchMultiCreate,
      method: 'post',
      data
    })
  }
  batchCreateCardList(data) {
    return request({
      url: api.virtual.batchCreateCardList,
      method: 'post',
      data
    })
  }
  multiList(data) {
    return request({
      url: api.virtual.multiList,
      method: 'post',
      data
    })
  }
  exportMultiList(data) {
    return request({
      url: api.virtual.exportMultiList,
      method: 'post',
      data
    })
  }
  multiCardInfo(params) {
    return request({
      url: api.virtual.multiCardInfo,
      method: 'get',
      params
    })
  }
  getSecurityCode(data) {
    return request({
      url: api.virtual.getSecurityCode,
      method: 'post',
      data
    })
  }
  multiDenominationList(data) {
    return request({
      url: api.virtual.multiDenominationList,
      method: 'post',
      data
    })
  }
  multiBillingList(data) {
    return request({
      url: api.virtual.multiBillingList,
      method: 'post',
      data
    })
  }
  getElements(data) {
    return request({
      url: api.virtual.getElements,
      method: 'post',
      data
    })
  }
  vanCancel(params) {
    return request({
      url: api.virtual.vanCancel,
      method: 'put',
      params
    })
  }
}
